// ----------------------------------------------------------------------------
// Component: Image Text Overlap
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import './_image-text-overlap.scss';